module.exports = __webpack_public_path__ + "img/chinesecompany73.79e0a104.png";